// Local Deps
import { makeGraphQLRequest } from '../utils/requestUtils';

export default async function submitItemSearchRequest(input) {
  const query = `
    mutation submitItemSearchRequest($input: ItemSearchRequestInput!) {
      submitItemSearchRequest(input: $input) {
        status
        error {
          message
        }
      }
    }
  `;

  const variables = { input };

  try {
    const data = await makeGraphQLRequest({ query, variables });
    return data;
  } catch (err) {
    console.error('submitItemSearchRequest error:', err);
    return { submitItemSearchRequest: { status: 'error', error: { message: 'Failed to submit search request' } } };
  }
}



// WEBPACK FOOTER //
// ./src/graphql/itemSearchRequest.js